import { render, staticRenderFns } from "./BirthdayInput.vue?vue&type=template&id=96eb1cb2&"
import script from "./BirthdayInput.vue?vue&type=script&lang=js&"
export * from "./BirthdayInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports